import { Injectable } from '@angular/core';
import { IMedicalQuestionnaire } from 'src/models';
import { ServiceBase } from '../service-base';
import { CognitoService } from '../cognito.service';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireService extends ServiceBase<IMedicalQuestionnaire> {
  propertyName = 'questionnaires';

  constructor(cognito: CognitoService, store: Store) {
    super(cognito, store, 'questionnaires');
  }

  public findAll(offset?: number, limit?: number, pharmacy?: string): Promise<IMedicalQuestionnaire[]> {
    const params = {
      offset,
      limit,
      pharmacy,
    };
    return super.findAll(params);
  }
}
